import './App.css';

import * as Sentry from '@sentry/react';
import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
import { Routes, BrowserRouter } from 'react-router-dom';
import { Box } from '@mui/material';
import { initSentry } from './lib/sentryClient';

import amplifyconfig from './amplifyconfiguration.json';
import { Amplify } from 'aws-amplify';

import { configureAutoTrack } from 'aws-amplify/analytics';
import Favicon from './components/Elements/Meta/Favicon';

initSentry();

Amplify.configure(amplifyconfig);

configureAutoTrack({
  // REQUIRED, turn on/off the auto tracking
  enable: true,
  // REQUIRED, the event type, it's one of 'event', 'pageView' or 'session'
  type: 'session',
  // OPTIONAL, additional options for the tracked event.
  options: {
    // OPTIONAL, the attributes of the event
    attributes: {
      customizableField: 'attr'
    }
  }
});

configureAutoTrack({
  // REQUIRED, turn on/off the auto tracking
  enable: true,
  // REQUIRED, the event type, it's one of 'event', 'pageView' or 'session'
  type: 'pageView',
  // OPTIONAL, additional options for the tracked event.
  options: {
    // OPTIONAL, the attributes of the event
    attributes: {
      customizableField: 'attr'
    },

    // OPTIONAL, the event name. By default, this is 'pageView'
    eventName: 'pageView',

    // OPTIONAL, the type of app under tracking. By default, this is 'multiPage'.
    // You will need to change it to 'singlePage' if your app is a single-page app like React
    appType: 'multiPage',

    // OPTIONAL, provide the URL for the event.
    urlProvider: () => {
      // the default function
      return window.location.origin + window.location.pathname;
    }
  }
});

configureAutoTrack({
  // REQUIRED, turn on/off the auto tracking
  enable: true,
  // REQUIRED, the event type, it's one of 'event', 'pageView' or 'session'
  type: 'event',
  // OPTIONAL, additional options for the tracked event.
  options: {
    // OPTIONAL, the attributes of the event
    attributes: {
      customizableField: 'attr'
    },
    // OPTIONAL, events you want to track. By default, this is 'click'
    events: ['click'],

    // OPTIONAL, the prefix of the selectors. By default, this is 'data-amplify-analytics-'
    // Per https://www.w3schools.com/tags/att_global_data.asp, always start
    // the prefix with 'data' to avoid collisions with the user agent
    selectorPrefix: 'data-amplify-analytics-'
  }
});

const App = () => (
  <Sentry.ErrorBoundary>
    <AppProvider>
      <Favicon />
      <Box marginBottom={'16px'}>
        <AppRoutes />
      </Box>
    </AppProvider>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </Sentry.ErrorBoundary>
);

export default App;
